import moment from "moment";
import React, { useState, useEffect } from "react";
import styles from "./Countdown.module.scss";

export default function Countdown() {
  const [countdownTimes, setCountdownTimes] = useState({
    days: "",
    hours: "",
    minutes: "",
    seconds: "",
  });
  const TIMESTAMP = moment(`1655002800000`, "x");
  let x;
  const countdown = (timestamp) => {
    var countDownDate = timestamp;
    x = setInterval(function () {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setCountdownTimes({ days, hours, minutes, seconds });
      if (distance < 0) {
        setCountdownTimes({
          days: 0,
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        clearInterval(x);
      }
    }, 1000);
  };
  useEffect(() => {
    countdown(TIMESTAMP);
    return () => {
      clearInterval(x);
    };
  }, []);

  return (
    <div className={styles.wrapper}>
      {Object.keys(countdownTimes).map((key) => (
        <CountdownElement key={key} string={key} time={countdownTimes[key]} />
      ))}
    </div>
  );
}
const CountdownElement = ({ time, string }) => {
  return (
    <div className={styles.elWrapper}>
      <div className={styles.elTime}>{time}</div>
      <div className={styles.elString}>{string}</div>
    </div>
  );
};
